import type { IProductItem } from '@inter-ikea-kompis/types';

/**
 * This class is used for storing items in a queue.
 */
export default class ProductItemQueue {
	private items: { [key: string]: IProductItem } = {};
	private timeout: number | null = null;
	// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
	private callbacks: Function[] = [];

	/**
	 * Releases waiting in queue.
	 *
	 * @param callbacks Callbacks.
	 */
	// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
	public releaseWaiting(callbacks: Function[]): void {
		for (const callback of callbacks) {
			callback({ items: [], callbacks: [] });
		}
	}

	/**
	 * Retrieves items in queue.
	 *
	 * @param items Array of items.
	 * @returns Promise.
	 */
	public async retrieveItems(
		items: IProductItem[]
		// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
	): Promise<{ items: IProductItem[]; callbacks: Function[] }> {
		this.addItems(items);

		return new Promise((resolve) => {
			if (this.timeout !== null) {
				this.callbacks.push(resolve);
			} else {
				this.timeout = window.setTimeout(() => {
					const items = Object.values(this.items);
					const callbacks = this.callbacks;
					this.callbacks = [];
					this.timeout = null;
					this.items = {};
					resolve({ items, callbacks });
				});
			}
		});
	}

	/**
	 * Adds items to queue.
	 *
	 * @param items Array of items.
	 */
	private addItems(items: IProductItem[]): void {
		for (const item of items) {
			this.items[item.type.toLowerCase() + item.id] = item;
		}
	}
}
